/**
 * @file Configuration overrides for the client.
 */

/** @type {import('@verosource/myhealth-web/src/config/networkConfig').NetworkConfig} */

const backendBaseUrl = "https://myhealth.gnb-doh.vsfcloud.com/myhealth-gateway"

const networkConfig = {
  keycloakBaseUrl: 'https://iam.myhealth.gnb-doh.vsfcloud.com/auth/',
  patientDataUrl: `${backendBaseUrl}/v1/patient/`,
  patientSummaryUrl: `${backendBaseUrl}/v1/patient-summary/`,
  patientSummaryManifestUrl: `${backendBaseUrl}/v1/patient-summary/manifest/`,
  patientSummaryViewerUrl: 'https://psv-vrdp.gnb.ca/',
  patientSummaryRevokeUrl: `${backendBaseUrl}/v1/patient-summary/manifest/revoke-access`,
  medicationUrl: `${backendBaseUrl}/v1/medication/`,
  messagingUrl: `${backendBaseUrl}/v1/messaging/`,
  immunizationUrl: `${backendBaseUrl}/v1/immunization/`,
  observationUrl: `${backendBaseUrl}/v1/diagnosticReport/`,
  diagnosticReportUrl: 'https://myhealth.gnb-doh.vsfcloud.com/myhealth-gateway/v1/diagnosticReport/',
  imagingUrl: `${backendBaseUrl}/v1/diagnosticImagingReport/`,
  encounterUrl: `${backendBaseUrl}/v2/encounter/`,
  alertUrl: 'https://myhealth.gnb-doh.vsfcloud.com/myhealth-gateway/v1/alert/',
  redirectUri: 'https://myhealth-web.myhealth.gnb-doh.vsfcloud.com/',
  loginUrl: `${backendBaseUrl}/v1/authentication/login`,
  authorizeUrl: 'https://id.gnb.ca/as/authorization.oauth2',
  clientId: 'MHNBPHRCLIENT',
  salesforcePortal: 'https://myhealth.gnb.ca/s/',
  loginProviderType: 'myhealth_broker_prod_new',
};

export default networkConfig;
